import {
  GET_CROP_LIST_LOADING,
  GET_CROP_LIST_SUCCESS,
  GET_CROP_LIST_FAILED,
  STATUS_DEFAULT,
  STATUS_GETTING,
  STATUS_GET_SUCCESS,
  STATUS_GET_FAILED,
} from 'Redux/actions/types';

const initialState = {
  status: STATUS_DEFAULT,
  statusCode: null,
  errorCode: null,
  data: null,
};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case GET_CROP_LIST_LOADING:
      return {
        status: STATUS_GETTING,
        errorCode: null,
      };

    case GET_CROP_LIST_SUCCESS:
      return {
        data: payload,
        status: STATUS_GET_SUCCESS,
        errorCode: null,
      };

    case GET_CROP_LIST_FAILED:
      return {
        status: STATUS_GET_FAILED,
        statusCode: payload.statusCode,
        errorCode: payload.errorCode,
      };

    default:
      return state;
  }
};
